import React, { Component } from 'react';
import { render } from 'react-dom';
import './style.css';
import firebase from './firebase.js'
//material-ui v.0.20.0
import FlatButton from 'material-ui/FlatButton';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Drawer from 'material-ui/Drawer';
import AppBar from 'material-ui/AppBar';
import MenuItem from 'material-ui/MenuItem';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import {
  Step,
  Stepper,
  StepLabel,
} from 'material-ui/Stepper';
import CircularProgress from 'material-ui/CircularProgress';
import SelectField from 'material-ui/SelectField';
import Snackbar from 'material-ui/Snackbar';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import NavigationExpandMoreIcon from 'material-ui/svg-icons/navigation/expand-more';
import DropDownMenu from 'material-ui/DropDownMenu';
import RaisedButton from 'material-ui/RaisedButton';
import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';
import Badge from 'material-ui/Badge';
import NotificationsIcon from 'material-ui/svg-icons/social/notifications';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import Toggle from 'material-ui/Toggle';
import Paper from 'material-ui/Paper';
import Popover, {PopoverAnimationVertical} from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import {BottomNavigation, BottomNavigationItem} from 'material-ui/BottomNavigation';
import IconLocationOn from 'material-ui/svg-icons/communication/location-on';
import ActionHome from 'material-ui/svg-icons/action/home';
import CommunicationCall from 'material-ui/svg-icons/communication/call';
import CommunicationChatBubble from 'material-ui/svg-icons/communication/chat-bubble';
import {indigo500} from 'material-ui/styles/colors';
import CommunicationEmail from 'material-ui/svg-icons/communication/email';
import AutoComplete from 'material-ui/AutoComplete';
import DatePicker from 'material-ui/DatePicker';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import Announcement from 'material-ui/svg-icons/action/announcement';
import Info from 'material-ui/svg-icons/action/account-circle';
import Exit from 'material-ui/svg-icons/action/exit-to-app';
import {orange500, blue500} from 'material-ui/styles/colors';
//import { Dimensions, Platform, PixelRatio } from 'react-native';
//material-ui v.1.00.0
//import from other class
import { Int_check, Number_check } from './Limitation.js';

//style section(preview)
const styles = {
  labelStyle: {
	fontSize: '14px',
	color: '#212121',
    },
    toolbarTextStyle: {
      color: '#212121',
      fontSize: '2vw',
      fontWeight: 'bold'
    },
    toolbarTextStyle2: {
      color: '#212121',
      fontSize: '2vw',
    },
    propContainer: {
    width: 200,
    overflow: 'hidden',
    margin: '20px auto 0',
  },
  propToggleHeader: {
    margin: '20px auto 10px',
  },
}
const style = {
  height: 100,
  width: 1500,
  margin: 20,
  textAlign: 'center',
  display: 'inline-block',
};



class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      currentpage: "Login",
      subpage: "Sign In",
      //logo: <img alt="MVHS Logo" src={require('./Img/Logo.png')} style={{width: 10, height: 58, position: 'relative', top: this.top, right: 30 }} />,
      user: null,
      loading: true,
      //list for each search option
      adminList: [],
      dateList: [],
      studentList: [],
      PrestudentList: [],
      LockerList: [],
      Ini_LockerList: [],
      SearchByNameList: [],
      SearchByIDList: [],
      SearchByLockerList: [],
      SearchByPeriodList: [],
      SeriesMatchList: [],

      opendialog: false,
      openD1: false,
      openD2: false,
      openD3: false,
      initialize: false,
      //Setting option
      Student_FirstName: "",
      Student_LastName: "",
      Student_ID: "",
      Student_Email: "",
      Student_LockerNumber: "",
      Student_SerisNumber: "",
      Student_LockCode: "",
      Student_Grade: "",
      Student_Instructor: "",
      Student_Room: "",
      Student_Period: "",
      Student_Active: false,
      //Search option input
      Search_Student_First: "",
      Search_Student_Last: "",
      Search_Student_ID : "",
      Search_Student_Locker : "",
      Search_Student_Period: "",
      Search_Student_Instructor: "",
      //show information option
      LockerRoom:"",
      FirstName : "",
      LastName : "",
      ID : "",
      Email : "",
      LockerNumber : "",
      LockNumber : "",
      PassCode : "",
      Grade : "",
      Instructor : "",
      Period : "",
      Active : "",
      //the selection of instructor
      value: null,
      value2: null,
      //down-up notification
      Warning: false,
      //Search option page for Admin control
      MenuValue : 1,
      //the selection of different search in Admin page
      selectedSearch: 1,

      openOption: false,
      openSearch: false,
      selected: [],

      selectedIndex: 0,
      //error note in fill info part
      StudentErrorText: 'This field is required',
      StudentErrorText_Period: 'This field is required',
      StudentErrorText_ID: 'This field is required',
      StudentErrorText_Series: 'This field is required',
      StudentErrorText_Locker: 'This field is required',
      StudentErrorText_Code: 'This field is required',
      StudentErrorText_Room: 'This field is required',
      //open Dialog
      openUpdateID: false,
      openUpdateLockerNumber: false,
      openUpdateLockNumber: false,
      openUpdateCode: false,
      openUpdateGrade: false,
      openUpdateInstructor: false,
      openUpdatePeriod: false,
      //print out combination Number
      output_Combination: "",
      ouput_Owner: "",

      number:"",
      code: "",

      dailynote: "",
      controlledDate: null,
      Announcement:{},
      added_note: "",
      //Snackbar
      openWarn: false,
      Datecheck: false,
      student_Message:"No Content!",
      today: "",
      Email_index: 0,
      checkpoint: {},
    };

    this.handleDrawerClick = this.handleDrawerClick.bind(this);
    this.handleMenuLogin = this.handleMenuLogin.bind(this);
    this.handleMenuInfo = this.handleMenuInfo.bind(this);
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.CheckID = this.CheckID.bind(this);
    this.UpdateAdminList = this.UpdateAdminList.bind(this);
    this.showMainPage = this.showMainPage.bind(this);
    this.handleGrade = this.handleGrade.bind(this);
    this.handlePeriod = this.handlePeriod.bind(this);
    this.handleID = this.handleID.bind(this);
    this.handleInstructor = this.handleInstructor.bind(this);
    this.handleLocker = this.handleLocker.bind(this);
    this.handleSeris = this.handleSeris.bind(this);
    this.handleCode = this.handleCode.bind(this);
    this.CheckFullFilled = this.CheckFullFilled.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleProveClick = this.handleProveClick.bind(this);
    this.handleRemoveClick = this.handleRemoveClick.bind(this);
    this.handleViewClick = this.handleViewClick.bind(this);
    this.SearchByName = this.SearchByName.bind(this);
    this.handleSearchID = this.handleSearchID.bind(this);
    this.select = this.select.bind(this);
    this.handleSearchFirstname = this.handleSearchFirstname.bind(this);
    this.handleSearchLastname = this.handleSearchLastname.bind(this);
    this.handleSearchLocker = this.handleSearchLocker.bind(this);
    this.SearchByLocker = this.SearchByLocker.bind(this);
    this.SearchByPeriod = this.SearchByPeriod.bind(this);
    this.handleSearchPeriod = this.handleSearchPeriod.bind(this);
    this.removeStudent = this.removeStudent.bind(this);
    this.CheckStudentList = this.CheckStudentList.bind(this);
    this.CheckPreStudentList = this.CheckPreStudentList.bind(this);
    this.handleCloseUpdate = this.handleCloseUpdate.bind(this);
    this.handleSubmitUpdate = this.handleSubmitUpdate.bind(this);
    this.report = this.report.bind(this);
    this.Announce = this.Announce.bind(this);
    this.SearchSeriesMatch = this.SearchSeriesMatch.bind(this);
  }

    handleSearchOpen = () => {
      this.setState({openSearch: true});
    };

    handleSearchClose1 = () => {
      this.setState({openSearch: false,
        FirstName : "",
        LastName : "",
        ID : "",
        Email : "",
        LockerNumber : "",
        LockNumber : "",
        PassCode : "",
        Grade : "",
        Instructor : "",
        LockerRoom: "",
        Period : "",
        Active : "",
        Search_Student_Instructor : "",
        Student_Instructor : "",
      });
    };

    handleSearchClose2 = () => {
      this.removeStudent();
      this.setState({openSearch: false, selected: [],
        FirstName : "",
        LastName : "",
        ID : "",
        Email : "",
        LockerNumber : "",
        LockNumber : "",
        PassCode : "",
        LockerRoom: "",
        Grade : "",
        Instructor : "",
        Period : "",
        Active : "",

      });
    };

    handleSearchClose3 = () => {
      const shoppingListDB = firebase.database().ref("Students");
      shoppingListDB.remove();
      this.setState({openD1: false});
      alert("All Students Information Deleted Successful");
      this.UpdateAdminList();
    };

    removeStudent(event){
      //Get the Shopping List database
      const shoppingListDB = firebase.database().ref("Students");

      //Remove the key given
      shoppingListDB.child(this.state.ID).remove();

      this.UpdateAdminList();

    }



  	select = (index) => this.setState({
      selectedSearch: index ,
      selected : [],
      SearchByNameList: [],
      SearchByIDList: [],
      SearchByLockerList: [],
      SearchByPeriodList: [],

      Search_Student_First: "",
      Search_Student_Last: "",
      Search_Student_ID : "",
      Search_Student_Locker : "",
      Search_Student_Period : "",
      Search_Student_Instructor : "",

      value : 0,
    });

  CheckFullFilled(){
    if(this.state.Student_Grade !== "" && this.state.Student_ID !== "" &&
      this.state.Student_Instructor !== "" && this.state.Student_LockCode !== "" &&
      this.state.Student_LockerNumber !== "" && this.state.Student_Period !== "" &&
      this.state.Student_SerisNumber !== "" && this.state.Student_Room !== ""){
      if(this.state.StudentErrorText === '' && this.state.StudentErrorText_Period === ''
        && this.state.StudentErrorText_ID === '' && this.state.StudentErrorText_Series === ''
        && this.state.StudentErrorText_Locker === '' && this.state.StudentErrorText_Code === ''
      && this.state.StudentErrorText_Room === ''){
           return true;
      }else{
        return false;
      }
    }
    else{
      return false;
    }
  }

  handleOptionClick = (event) => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      openOption: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestOptionClose = () => {
    this.setState({
      openOption: false,
    });
  };

  handleProveClick(event){
    if(this.state.selected === "all"){
      this.state.PrestudentList.forEach((student) => {
        var aStudent = {
          Active : true,
          Email : student.Email,
          FirstName : student.FirstName,
          Grade : student.Grade,
          ID : student.ID,
          Instructor : student.Instructor,
          LastName : student.LastName,
          LockNumber : student.LockNumber,
          LockerNumber : student.LockerNumber,
          PassCode : student.PassCode,
          Period : student.Period,
          LockerRoom: student.LockerRoom,
        }
        const studentDB = firebase.database().ref("Students");

        studentDB.child(student.ID).set(aStudent);
      }
      );
      this.UpdateAdminList();
      this.setState({selected : []});
    }
    else if(this.state.selected.length > 0){
      let count = 0;
      this.state.PrestudentList.forEach((student) => {
        if(this.state.selected.includes(count)){
          var aStudent = {
          Active : true,
          Email : student.Email,
          FirstName : student.FirstName,
          Grade : student.Grade,
          ID : student.ID,
          Instructor : student.Instructor,
          LastName : student.LastName,
          LockNumber : student.LockNumber,
          LockerNumber : student.LockerNumber,
          PassCode : student.PassCode,
          Period : student.Period,
          LockerRoom: student.LockerRoom,
        }
        const studentDB = firebase.database().ref("Students");

        studentDB.child(student.ID).set(aStudent);
        }
        count++;
      }
      );
        this.setState({selected : []});
       this.UpdateAdminList();
    }else{
      alert("No Student Selected");
    }
  }

  handleRemoveClick(event) {
    if(this.state.selected === "all"){
      this.state.PrestudentList.forEach((student) => {

        const shoppingListDB = firebase.database().ref("Students");

        //Remove the key given
        shoppingListDB.child(student.ID).remove();
      }
    );
      this.UpdateAdminList();
      this.setState({selected : []});
    }
    else if(this.state.selected.length > 0){
      let count = 0;
      this.state.PrestudentList.forEach((student) => {
        if(this.state.selected.includes(count)){

          const shoppingListDB = firebase.database().ref("Students");

          //Remove the key given
          shoppingListDB.child(student.ID).remove();
        }
        count++;
      }
      );
        this.setState({selected : []});
       this.UpdateAdminList();
    }else{
      alert("No Student Selected");
    }
  }

  handleOpen = () => {
    this.setState({openD1: true});
  };

  handleCheck = () => {
    this.setState({openD3: true});
  };

  handleMenuChange = (event, index, value) => this.setState({MenuValue : value});

   handleSubmit(event) {
    //To add an item, you need to specify the key.
    //In this case, it is new unique number.  We can use the length of the Student list as it is the next number in our list.

    //Add a new key to Student Lists. It will return the new item of that key
    const StudentListDB = firebase.database().ref("Students/" + this.state.Student_ID);

    //This has to match your firebase database
    const aStudent = {
        FirstName : this.state.Student_FirstName,
        LockerRoom: this.state.Student_Room,
        LastName : this.state.Student_LastName,
        Email : this.state.Student_Email,
        ID : this.state.Student_ID,
        LockerNumber : this.state.Student_LockerNumber,
        LockNumber : this.state.Student_SerisNumber,
        PassCode: this.state.Student_LockCode,
        Grade: this.state.Student_Grade,
        Instructor: this.state.Student_Instructor,
        Period: this.state.Student_Period,
        Active: this.state.Student_Active,
    }


    //Add a value to the new student to firebase
    StudentListDB.set(
      aStudent
    );





    //update the screen, and clear out the form
    this.setState({
      isLoading : true,
      Student_FirstName: "",
      Student_LastName: "",
      Student_ID: "",
      Student_Email: "",
      Student_LockerNumber: "",
      Student_SerisNumber: "",
      Student_LockCode: "",
      Student_Grade: "",
      Student_Instructor: "",
      Student_Period: "",
      Student_Room: "",
      Student_Active: false,
      StudentErrorText: '',
      StudentErrorText_Period: '',
      StudentErrorText_ID: '',
      StudentErrorText_Series: '',
      StudentErrorText_Locker: '',
      StudentErrorText_Code: '',
      StudentErrorText_Room: '',
    });

    //this will download the Student list from firebase with the update value
    this.UpdateAdminList();

    //prevent the page from reloading
    //event.preventDefault();
  }


  handleClose(input){
    if(input === 0){
      this.setState({openD1: false});
    }else if(input === 1){
      this.setState({openD1: false, Initialize: true});
    }else if(input === 2){
      this.setState({openD2: false});
    }else if(input === 3){
      this.handleSubmit();
    }else if(input === 4){
      this.setState({openD3 : false});
    }else if(input === 5){
      this.setState({openD1 : false});
    }
  };

  handleNext = () => {
    if(this.CheckFullFilled()){
      let name = this.state.user.displayName;
      let namelist = name.split(" ");
      this.setState({
        Student_FirstName : namelist[0],
        Student_LastName : namelist[1],
        Student_Email : this.state.user.email,
        openD2: true,
      });
    }else{
      this.setState({Warning : true});
    }
  };
  //Student Grade textfield information checking
  handleRoom = (event, index, value) => {
    if(value === 1){
      this.setState({ value2 : value, Student_Room : "Boy", StudentErrorText_Room: ""});
      this.checksame(this.state.Student_LockerNumber, "Boy");
    }else if(value === 2){
		  this.setState({ value2 : value, Student_Room : "Girl", StudentErrorText_Room: ""});
      this.checksame(this.state.Student_LockerNumber, "Girl");
    }
	}
  //Student Grade textfield information checking
  handleGrade = (event, value) => {
    if(value != "" && Int_check(value,"grade")){
      this.setState({ Student_Grade: value, StudentErrorText: '' });
    }else if(!Int_check(value,"grade") && value != ""){
      this.setState({ Student_Grade: value, StudentErrorText: 'Please enter the correct form' });
    }else{
      this.setState({ Student_Grade: value, StudentErrorText: 'This field is required' });
    }
	}
  //Student Period textfield information checking
  handlePeriod = (event, value) => {
    if(value != "" && Int_check(value,"period")){
      this.setState({ Student_Period: value, StudentErrorText_Period: '' });
    }else if(!Int_check(value,"period") && value != ""){
      this.setState({ Student_Period: value, StudentErrorText_Period: 'Please enter the correct form' });
    }else{
      this.setState({ Student_Period: value, StudentErrorText_Period: 'This field is required' });
    }

		this.setState({ Student_Period: value });
	}
  //Student ID textfield information checking
  handleID = (event, value) => {
    if(value.length === 5){
      if(!this.ID_check(value, this.state.studentList, this.state.PrestudentList) && this.IsNumeric(value)){
        this.setState({ Student_ID: value, StudentErrorText_ID: ''});
      }else{
        this.setState({ Student_ID: value, StudentErrorText_ID: 'Please check your student ID with the instructor'});
      }
    }else{
      this.setState({ Student_ID: value, StudentErrorText_ID: 'This field is required'});
    }
	}

  ID_check(input){
    var check = false;
    for(var i = 0; i< this.state.studentList.length; i++){
      if(input === this.state.studentList[i].ID){
        check = true;
      }
    }
    for(var a = 0; a< this.state.PrestudentList.length; a++){
      if(input === this.state.PrestudentList[a].ID){
        check = true;
      }
    }
    return check;
  }
  //search Student Firstname textfield information checking
  handleSearchFirstname = (event, value) => {
		this.setState({ Search_Student_First: event.target.value });
	}
  //search Student Lastname textfield information checking
  handleSearchLastname = (event, value) => {
		this.setState({ Search_Student_Last: event.target.value });
	}
  //search Student ID textfield information checking
  handleSearchID = (event, value) => {
    this.setState({Search_Student_ID : event.target.value});
  }
  //search Student Locker number textfield information checking
  handleSearchLocker = (event, value) => {
    this.setState({Search_Student_Locker : event.target.value});
  }
  //search Student Period textfield information checking
  handleSearchPeriod = (event, value) => {
    this.setState({Search_Student_Period : event.target.value});
  }

  //Student's instructor textfield information checking
  handleInstructor = (event, index, value) => {
    if(value === 0){
      this.setState({ value, Search_Student_Instructor : ""});
    }else if(value >= 1 && value <= 7){
		  this.setState({ value, Student_Instructor: this.state.adminList[value].firstname , Search_Student_Instructor : this.state.adminList[value].firstname});
    }else if(value === 8){
      this.setState({ value, Student_Instructor: "All" , Search_Student_Instructor : "All"});
    }
	}
  //Student Locker number textfield information checking

  IsNumeric(input){
    var RE = /^-{0,1}\d*\.{0,1}\d+$/;
    return (RE.test(input));
  }

  handleLocker = (event, value) => {
    if(this.state.Student_Room !== ""){
      this.checksame(value, this.state.Student_Room);
    }else{
      this.setState({ Student_LockerNumber: value , StudentErrorText_Locker: 'Please choose the locker room first' });
    }
	}

  checksame(number, room){
    console.log(number);
    var checksame = false;
    if(number.length === 3 && this.IsNumeric(number)){
      for(var i = 0; i < this.state.LockerList.length; i++){
        if(room === "Boy"){
          if(parseInt(number) <= 586){
            if(number === this.state.LockerList[i].Locker_Number && !this.state.LockerList[i].Boy){
              this.setState({ Student_LockerNumber: number , StudentErrorText_Locker: '', });
              checksame = true;
              break;
            }else if(this.state.LockerList[i].Boy && number === this.state.LockerList[i].Locker_Number){
              this.setState({ Student_LockerNumber: number , StudentErrorText_Locker: 'Sorry, This Locker has been selected', });
              checksame = true;
              break;
            }
          }else{
            this.setState({ Student_LockerNumber: number , StudentErrorText_Locker: 'Please enter a valid locker number', });
          }
        }else if(room === "Girl"){
          if(number === this.state.LockerList[i].Locker_Number && !this.state.LockerList[i].Girl){
            this.setState({ Student_LockerNumber: number , StudentErrorText_Locker: '', });
            checksame = true;
            break;
          }else if(this.state.LockerList[i].Girl && number === this.state.LockerList[i].Locker_Number){
            this.setState({ Student_LockerNumber: number , StudentErrorText_Locker: 'Sorry, This Locker has been selected', });
            checksame = true;
            break;
          }
        }
      }
      //ppppp
      if(!checksame){
        this.setState({ Student_LockerNumber: number , StudentErrorText_Locker: 'Please enter a valid locker number', });
      }
    }else if(number.length === 0){
      this.setState({ Student_LockerNumber: number , StudentErrorText_Locker: 'This field is required', });
    }else{
      this.setState({ Student_LockerNumber: number , StudentErrorText_Locker: 'Please enter the correct form' });
    }
  }
  //Student Lock number textfield information checking
  handleSeris = (event, value) => {
    if(value.length !== 0){
		  this.setState({ Student_SerisNumber: value, StudentErrorText_Series:''});
    }else{
      this.setState({ Student_SerisNumber: value, StudentErrorText_Series:'This field is required',output_Combination : "", ouput_Owner: ""});
    }
    /*else if(value.length === 0){
      this.setState({ Student_SerisNumber: value, StudentErrorText_Series:'This field is required',output_Combination : "", ouput_Owner: ""});
    }else{
      this.setState({ Student_SerisNumber: value, StudentErrorText_Series:'Please enter the correct form',output_Combination : "", ouput_Owner: ""});
    }*/
	}
  //Student Lock code textfield information checking
  handleCode = (event, value) => {
    if(value.length === 0){
      this.setState({ Student_LockCode: value, StudentErrorText_Code: 'This field is required' });
    }else{
      this.setState({ Student_LockCode: value, StudentErrorText_Code: '' });
    }
    /*
    else if(value.length === 8){
      var list = value.split("-");
      if(this.IsNumeric(list[0]) && this.IsNumeric(list[1]) && this.IsNumeric(list[2])){
        this.setState({ Student_LockCode: value, StudentErrorText_Code: "" });
      }else{
        this.setState({ Student_LockCode: value, StudentErrorText_Code: "Please enter the correct form" });
      }
    }else{
      this.setState({ Student_LockCode: value, StudentErrorText_Code: "Please enter the correct form" });
    }*/

	}

  handleViewClick(event, input){
      if(this.state.selected.length > 0){
        if(input == 1){
            const list = [];
            const index = this.state.selected[0];
            list.push(this.state.SearchByNameList[index]);
            this.setState({
              FirstName : list[0].FirstName,
              LastName : list[0].LastName,
              ID : list[0].ID,
              Email : list[0].Email,
              LockerNumber : list[0].LockerNumber,
              LockNumber : list[0].LockNumber,
              PassCode : list[0].PassCode,
              LockerRoom : list[0].LockerRoom,
              Grade : list[0].Grade,
              Instructor : list[0].Instructor,
              Period : list[0].Period,
              Active : list[0].Active,
            });
          }
          else if(input == 2){
            const list = [];
            const index = this.state.selected[0];
            list.push(this.state.SearchByIDList[index]);
            this.setState({
              FirstName : list[0].FirstName,
              LastName : list[0].LastName,
              ID : list[0].ID,
              Email : list[0].Email,
              LockerNumber : list[0].LockerNumber,
              LockNumber : list[0].LockNumber,
              PassCode : list[0].PassCode,
              LockerRoom : list[0].LockerRoom,
              Grade : list[0].Grade,
              Instructor : list[0].Instructor,
              Period : list[0].Period,
              Active : list[0].Active,
            });
          }
          else if(input == 3){
            const list = [];
            const index = this.state.selected[0];
            list.push(this.state.SearchByLockerList[index]);
            this.setState({
              FirstName : list[0].FirstName,
              LastName : list[0].LastName,
              ID : list[0].ID,
              Email : list[0].Email,
              LockerNumber : list[0].LockerNumber,
              LockNumber : list[0].LockNumber,
              PassCode : list[0].PassCode,
              LockerRoom : list[0].LockerRoom,
              Grade : list[0].Grade,
              Instructor : list[0].Instructor,
              Period : list[0].Period,
              Active : list[0].Active,
            });
          }
          else if(input == 4){
            const list = [];
            const index = this.state.selected[0];
            list.push(this.state.SearchByPeriodList[index]);
           this.setState({
              FirstName : list[0].FirstName,
              LastName : list[0].LastName,
              ID : list[0].ID,
              Email : list[0].Email,
              LockerNumber : list[0].LockerNumber,
              LockNumber : list[0].LockNumber,
              PassCode : list[0].PassCode,
              LockerRoom : list[0].LockerRoom,
              Grade : list[0].Grade,
              Instructor : list[0].Instructor,
              Period : list[0].Period,
              Active : list[0].Active,
            });
          }
          this.setState({openSearch : true});
        }else{
          alert("Please select a student");
      }
    }


    SearchByName(){
    if(this.state.Search_Student_First !== "" && this.state.Search_Student_Last !== ""){
      const list = [];
      for(let i = 0; i < this.state.studentList.length; i++){
        if(this.state.studentList[i].FirstName.toLowerCase() === this.state.Search_Student_First.toLowerCase() && this.state.studentList[i].LastName.toLowerCase() === this.state.Search_Student_Last.toLowerCase()){
          list.push(this.state.studentList[i]);
        }
      }
      this.setState({SearchByNameList : list});
    }else if(this.state.Search_Student_First !== ""){
      const list = [];
      for(let i = 0; i < this.state.studentList.length; i++){
        if(this.state.studentList[i].FirstName.toLowerCase() === this.state.Search_Student_First.toLowerCase() ){
          list.push(this.state.studentList[i]);
        }
      }
      this.setState({SearchByNameList : list});
    }else if(this.state.Search_Student_Last !== ""){
      const list = [];
      for(let i = 0; i < this.state.studentList.length; i++){
        if(this.state.studentList[i].LastName.toLowerCase() === this.state.Search_Student_Last.toLowerCase()){
          list.push(this.state.studentList[i]);
        }
      }
      this.setState({SearchByNameList : list});
    }else{
      const list = [];
      this.setState({SearchByNameList : list });
    }
  }

  SearchByID(){
    if(this.state.Search_Student_ID !== ""){
      const list = [];
      for(let i = 0; i < this.state.studentList.length; i++){
        if(this.state.studentList[i].ID === this.state.Search_Student_ID){
          list.push(this.state.studentList[i]);
        }
      }
      this.setState({SearchByIDList : list});
    }else{
      const list = [];
      this.setState({SearchByIDList : list });
    }
  }

  SearchByLocker(){
    if(this.state.Search_Student_Locker !== ""){
      const list = [];
      for(let i = 0; i < this.state.studentList.length; i++){
        if(this.state.studentList[i].LockerNumber === this.state.Search_Student_Locker){
          list.push(this.state.studentList[i]);
        }
      }
      this.setState({SearchByLockerList : list});
    }else{
      const list = [];
      this.setState({SearchByLockerList : list });
    }
  }

  SearchByPeriod(){
    if(this.state.Search_Student_Period !== "" && this.state.Search_Student_Instructor !== ""){
      const list = [];
      for(let i = 0; i < this.state.studentList.length; i++){
        if(this.state.studentList[i].Period === this.state.Search_Student_Period && this.state.studentList[i].Instructor === this.state.Search_Student_Instructor){
          list.push(this.state.studentList[i]);
        }
      }
      this.setState({SearchByPeriodList : list});
    }else if(this.state.Search_Student_Period !== ""){
      const list = [];
      for(let i = 0; i < this.state.studentList.length; i++){
        if(this.state.studentList[i].Period === this.state.Search_Student_Period ){
          list.push(this.state.studentList[i]);
        }
      }
      this.setState({SearchByPeriodList : list});
    }else if(this.state.Search_Student_Instructor !== ""){
      const list = [];
      for(let i = 0; i < this.state.studentList.length; i++){
        if(this.state.studentList[i].Instructor === this.state.Search_Student_Instructor){
          list.push(this.state.studentList[i]);
        }
      }
      this.setState({SearchByPeriodList : list});
    }else{
      const list = [];
      this.setState({SearchByPeriodList : list });
    }
  }

  SearchSeriesMatch(){
    let com = "";
    if(this.state.StudentErrorText_Series === "" && this.state.Student_SerisNumber.length == 6){
      for(let i = 0; i < this.state.SeriesMatchList.length; i++){
        if(this.state.SeriesMatchList[i].Series === this.state.Student_SerisNumber){
          com = this.state.SeriesMatchList[i].Combination;
        }
      }
      if(com.length>0){
        let check = false;
        let name = "";
        for(let i = 0; i < this.state.studentList.length; i++){
          if(this.state.studentList[i].LockNumber === this.state.Student_SerisNumber){
            check = true;
            name = this.state.studentList[i].FirstName +" " + this.state.studentList[i].LastName;
          }
        }
        if(check){
          this.setState({output_Combination : com, ouput_Owner: name});
        }else{
          this.setState({output_Combination : com, ouput_Owner: "No Owner"});
        }
      }else{
        this.setState({output_Combination: "No Result Found", ouput_Owner : ""});
      }
    }else{
      alert("Please enter a valid series code");
    }
  }
  drawTable(input){

    return(
      <div>
        <MuiThemeProvider>
            <div>
              <Table onRowSelection={this.handleRowSelection}
                height={'600px'}
                fixedHeader={true}
                fixedFooter={true}
                selectable={true}
                multiSelectable={false}
              >
                <TableHeader
                  displaySelectAll={true}
                  adjustForCheckbox={true}
                  enableSelectAll={false}
                >

                  <TableRow>
                    <TableHeaderColumn tooltip="The ID">Student ID</TableHeaderColumn>
                    <TableHeaderColumn tooltip="The Name">Student Name</TableHeaderColumn>
                    <TableHeaderColumn tooltip="The Grade">Current Grade</TableHeaderColumn>
                    <TableHeaderColumn tooltip="The Instructor">Instructor</TableHeaderColumn>
                    <TableHeaderColumn tooltip="The Period">Period</TableHeaderColumn>
                  </TableRow>
                </TableHeader>
                <TableBody className="table"
                  displayRowCheckbox={true}
                  deselectOnClickaway={false}
                  showRowHover={true}
                  stripedRows={true}
                >

                  if(input === 1){
                    this.state.SearchByNameList.map( (item, index) => (
                    <TableRow selected={this.isSelected(index)}>
                      <TableRowColumn>{item.ID}</TableRowColumn>
                      <TableRowColumn>{item.FirstName + " " + item.LastName}</TableRowColumn>
                      <TableRowColumn>{item.Grade}</TableRowColumn>
                      <TableRowColumn>{item.Instructor}</TableRowColumn>
                      <TableRowColumn>{item.Period}</TableRowColumn>
                    </TableRow>
                    ))
                  }else if(input === 2){
                    this.state.SearchByIDList.map( (item, index) => (
                    <TableRow selected={this.isSelected(index)}>
                      <TableRowColumn>{item.ID}</TableRowColumn>
                      <TableRowColumn>{item.FirstName + " " + item.LastName}</TableRowColumn>
                      <TableRowColumn>{item.Grade}</TableRowColumn>
                      <TableRowColumn>{item.Instructor}</TableRowColumn>
                      <TableRowColumn>{item.Period}</TableRowColumn>
                    </TableRow>
                    ))
                  }else if(input === 3){
                    this.state.SearchByLockerList.map( (item, index) => (
                    <TableRow selected={this.isSelected(index)}>
                      <TableRowColumn>{item.ID}</TableRowColumn>
                      <TableRowColumn>{item.FirstName + " " + item.LastName}</TableRowColumn>
                      <TableRowColumn>{item.Grade}</TableRowColumn>
                      <TableRowColumn>{item.Instructor}</TableRowColumn>
                      <TableRowColumn>{item.Period}</TableRowColumn>
                    </TableRow>
                    ))
                  }else if(input === 4){
                    this.state.SearchByPeriodList.map( (item, index) => (
                    <TableRow selected={this.isSelected(index)}>
                      <TableRowColumn>{item.ID}</TableRowColumn>
                      <TableRowColumn>{item.FirstName + " " + item.LastName}</TableRowColumn>
                      <TableRowColumn>{item.Grade}</TableRowColumn>
                      <TableRowColumn>{item.Instructor}</TableRowColumn>
                      <TableRowColumn>{item.Period}</TableRowColumn>
                    </TableRow>
                    ))
                  }

                </TableBody>
              </Table>
            </div>
          </MuiThemeProvider>
      </div>
    );
  }
  //subs functions
  handleDrawerClick() {
    if (this.state.open == false)
      this.setState({ open: true });
    else
      this.setState({ open: false });
  }

  handleMenuLogin() {
    this.setState({currentpage : "Login"});
    this.handleDrawerClick();
  }

  handleMenuInfo() {
    this.setState({currentpage : "Info"});
    this.handleDrawerClick();
  }

  handleRequestClose = () => {
    this.setState({
      Warning: false,
    });
  };
  ////////////////////////////////////////
  menuControl() {
    const style = {
      height: 300,
      width: 350,
      margin: 20,
      textAlign: 'center',
      display: 'inline-block',
    };

    const message = "mailto:" + "allengaosh@icloud.com";
    const call = "tel:1-949-228-6289";
    if(this.state.currentpage === "Login"){
      return (
        <div>
          /*<div className="logo">
            {this.state.logo}
          </div>*/
          <br /><br /><br /><br />
          <center>
            <h1>Sign In</h1>
          </center>
      </div>
      );
    }else if(this.state.currentpage === "Info"){
      return (<div>
      <br /><br /><br /><br />
      <center><h1>App Information</h1></center>
      <br /><br />
      <text>This app is developed for Mountain View High school PE students to sign up for a locker easier and faster, and also for
       instructors to manage their students’ information and classes more efficiently.</text>
      <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
      <center><h3>App Developer</h3></center>
      <MuiThemeProvider>
        <center>
          <Paper style={style} zDepth={2}>
            <ListItem disabled={true} primaryText= {"Unnamed Contributor"}/>
            <ListItem disabled={true} secondaryText= {"class of 2019"}/>
            <Divider />
            <ListItem
              leftIcon={<CommunicationCall color={indigo500} />}
              rightIcon={<CommunicationChatBubble />}
              primaryText="(xxx) xxx - xxxx"
              secondaryText="Mobile"
              href={call}
            />
            <ListItem
             leftIcon={<CommunicationEmail color={indigo500} />}
             primaryText="100021198@mvla.net"
             secondaryText="Personal"
             href={message}
           />
          </Paper>
        </center>
      </MuiThemeProvider>
      </div>);
    }
  }


  componentDidMount() {
    //Gets call once when loading the page
    //setInterval(this.reset , 1000);
    //when you hit reload, this will check if you already logged in
    //and will set the user variable accordingly.
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({ user });
        this.UpdateAdminList();
      }

      this.setState({ loading: false });
    });

    firebase.auth().getRedirectResult().then( function (result){
      // This gives you a Google Access Token. You can use it to access the Google API.
      const token = result.credential.accessToken;
      // The signed-in user info.
      const user = result.user;

      //Set the state user variable
      this.setState({ user });
      // ...
      }).catch(function(error) {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        const credential = error.credential;
        // ...

    });
  }

  UpdateAdminList(){
    //get the current date
    var today2 = new Date();
    var dd = today2.getDate();
    var mm = today2.getMonth()+1; //January is 0!
    var yyyy = today2.getFullYear();
    if(dd<10) {
        dd = '0'+dd
    }
    if(mm<10) {
        mm = '0'+mm
    }
    today2 = mm + '-' + dd + '-' + yyyy;
    this.setState({today: today2});
    //The following code get a particular table
      const adminListDB = firebase.database().ref("Admin");
      //Store content of the database into an array to be used
      //to set the state later.
      var adminListTemp = [];
      var index;
      var index2;
      //Get shoppingList from the DB and add it to the local list.
      adminListDB.on('value', snapshot => {
      adminListTemp = [];
      snapshot.forEach(childSnapShot => {
        //console.log(childSnapShot.key + " : "  + childSnapShot.val());
        const item =
        {
            email : childSnapShot.val().Email,
            firstname : childSnapShot.val().FirstName,
            lastname : childSnapShot.val().LastName
        }
        //Add an item object to the shoppingListTemp Array
        adminListTemp.push(item);
      });
      //set the shoppingLItemTemp Array to the state shoppingList, and load to false
      this.setState({ adminList: adminListTemp, Loading: false });

    });
    /////////////////////////////////////////////////////////////
    //The following code get a particular table
      const dateListDB = firebase.database().ref("Date");
      //Store content of the database into an array to be used
      //to set the state later.
      var dateListTemp = [];
      //Get shoppingList from the DB and add it to the local list.
      dateListDB.on('value', snapshot => {
      dateListTemp = [];
      snapshot.forEach(childSnapShot => {

        const item =
        {
          date : childSnapShot.key,
          John : childSnapShot.val().John,
          Julie : childSnapShot.val().Julie,
          Rick : childSnapShot.val().Rick,
          Shelley : childSnapShot.val().Shelley,
          Tami : childSnapShot.val().Tami,
          Kirk: childSnapShot.val().Kirk,
          Todd: childSnapShot.val().Todd,
          All : childSnapShot.val().All,
        }

        //Add an item object to the shoppingListTemp Array
        dateListTemp.push(item);
      });
      //set the shoppingLItemTemp Array to the state shoppingList, and load to false
      this.setState({dateList: dateListTemp});

    });
    /////////////////////////////////////////////////////////////

    //Empty the firebase lock List
    if(this.state.LockerList.length !== 0 && this.state.Ini_LockerList.length !== 0){
      //console.log("the size of the lockers: " + this.state.Ini_LockerList.length);
      for(var i = 0; i < this.state.Ini_LockerList.length; i++){
        const Locker_ListDB2 = firebase.database().ref("Locker/" + this.state.Ini_LockerList[i].Locker_Number);

        //This has to match your firebase database
        const LStudent2 = {
          Disability : this.state.Ini_LockerList[i].Disability,
          Girl : this.state.Ini_LockerList[i].Girl,
          Boy : this.state.Ini_LockerList[i].Boy,
        }


        //Add a value to the new student to firebase
        Locker_ListDB2.set(
          LStudent2
        );
      }
    }

    //////////////////////////////////////////////////////////////
    const studentListDB = firebase.database().ref("Students");

    //Store content of the database into an array to be used
    //to set the state later.
    let studentListTemp = [];
    let PrestudentListTemp = [];
    //Get StudentList from the DB and add it to the local list.
    studentListDB.on('value', snapshot => {
      studentListTemp = [];
      PrestudentListTemp = [];

      snapshot.forEach(childSnapShot => {
        //console.log( childSnapShot.key + " : "  + childSnapShot.val());

        const aStudent = {
            Active : childSnapShot.val().Active,
            Email : childSnapShot.val().Email,
            FirstName : childSnapShot.val().FirstName,
            Grade : childSnapShot.val().Grade,
            ID : childSnapShot.val().ID,
            Instructor : childSnapShot.val().Instructor,
            LastName : childSnapShot.val().LastName,
            LockNumber : childSnapShot.val().LockNumber,
            LockerNumber : childSnapShot.val().LockerNumber,
            PassCode : childSnapShot.val().PassCode,
            Period : childSnapShot.val().Period,
            LockerRoom: childSnapShot.val().LockerRoom,
        }
        if(this.state.user.email === aStudent.Email){
          this.setState({checkpoint : aStudent})
        }
        //change the local locker list
        if(aStudent.LockerRoom === "Boy"){
          const Locker_ListDB = firebase.database().ref("Locker/" + aStudent.LockerNumber);
          //This has to match your firebase database
          const LStudent = {
            Disability : false,
            Girl : false,
            Boy : true,
          }
          Locker_ListDB.set(
            LStudent
          );
        }else if(aStudent.LockerRoom === "Girl"){
          const Locker_ListDB = firebase.database().ref("Locker/" + aStudent.LockerNumber);
          //This has to match your firebase database
          const LStudent = {
            Disability : false,
            Girl : true,
            Boy : false,
          }
          Locker_ListDB.set(
            LStudent
          );
        }


        //Add an item object to the StudentListTemp Array
        if(childSnapShot.val().Active){
          studentListTemp.push(aStudent);
        }
        else{
          PrestudentListTemp.push(aStudent);
        }


      });

      //set the StudentLItemTemp Array to the state StudentList, and load to false
      this.setState({ studentList: studentListTemp, PrestudentList : PrestudentListTemp, Loading: false });

    });
    //this.checksame(this.state.Student_LockerNumber, this.state.Student_Room);
    this.SearchByName();
    this.SearchByID();
    this.SearchByLocker();
    this.SearchByPeriod();
    ///////////////////////////////////////////////////////////
    const LockerListDB = firebase.database().ref("Locker");

    var LockerListTemp = [];
    var Ini_LockerListTemp = [];

    LockerListDB.on('value', snapshot => {
    LockerListTemp = [];
    Ini_LockerListTemp = [];
    snapshot.forEach(childSnapShot => {
      //console.log( childSnapShot.key + " : "  + childSnapShot.val());

      const item =
      {
          Disability : childSnapShot.val().Disability,
          Girl : childSnapShot.val().Girl,
          Boy : childSnapShot.val().Boy,
          Locker_Number : childSnapShot.key,
      }

      const item2 =
      {
          Disability : false,
          Girl : false,
          Boy : false,
          Locker_Number : childSnapShot.key,
      }

      //Add an item object to the shoppingListTemp Array
      LockerListTemp.push(item);
      Ini_LockerListTemp.push(item2);
    });
    //set the shoppingLItemTemp Array to the state shoppingList, and load to false
    this.setState({ LockerList: LockerListTemp, Ini_LockerList: Ini_LockerListTemp, Loading: false });
    //console.log(this.state.adminList.length);

  });
  /////////////////////////////////////////////////////////
  const CodeListDB = firebase.database().ref("Matches");
  //Store content of the database into an array to be used
  //to set the state later.
  var CodeListTemp = [];
  //Get shoppingList from the DB and add it to the local list.
  CodeListDB.on('value', snapshot => {
  CodeListTemp = [];
  snapshot.forEach(childSnapShot => {
    //( childSnapShot.key + " : "  + childSnapShot.val());

    const item =
    {
        Series : childSnapShot.val().Series_Number,
        Combination : childSnapShot.val().Combination,
    }
    //Add an item object to the shoppingListTemp Array
    CodeListTemp.push(item);
  });
  //set the shoppingLItemTemp Array to the state shoppingList, and load to false
  this.setState({ SeriesMatchList: CodeListTemp, Loading: false });
  //find out the Matches
  for(var i = 0; i < this.state.dateList.length; i++){
    let str = this.state.dateList[i].date;
    let str2 = "";
    if(str.substring(4,7) === "Jan"){
      str2 = '01-' + str.substring(8,10) + '-' + str.substring(11,15);
    }else if(str.substring(4,7) === "Feb"){
      str2 = '02-' + str.substring(8,10) + '-' + str.substring(11,15);
    }else if(str.substring(4,7) === "Mar"){
      str2 = '03-' + str.substring(8,10) + '-' + str.substring(11,15);
    }else if(str.substring(4,7) === "Apr"){
      str2 = '04-' + str.substring(8,10) + '-' + str.substring(11,15);
    }else if(str.substring(4,7) === "May"){
      str2 = '05-' + str.substring(8,10) + '-' + str.substring(11,15);
    }else if(str.substring(4,7) === "Jun"){
      str2 = '06-' + str.substring(8,10) + '-' + str.substring(11,15);
    }else if(str.substring(4,7) === "Jul"){
      str2 = '07-' + str.substring(8,10) + '-' + str.substring(11,15);
    }else if(str.substring(4,7) === "Aug"){
      str2 = '08-' + str.substring(8,10) + '-' + str.substring(11,15);
    }else if(str.substring(4,7) === "Sep"){
      str2 = '09-' + str.substring(8,10) + '-' + str.substring(11,15);
    }else if(str.substring(4,7) === "Oct"){
      str2 = '10-' + str.substring(8,10) + '-' + str.substring(11,15);
    }else if(str.substring(4,7) === "Nov"){
      str2 = '11-' + str.substring(8,10) + '-' + str.substring(11,15);
    }else if(str.substring(4,7) === "Dec"){
      str2 = '12-' + str.substring(8,10) + '-' + str.substring(11,15);
    }
    if(this.state.today === str2){
      if(this.state.dateList[i].All === ""){
        if(this.state.dateList[i][this.state.checkpoint.Instructor] === ""){
          this.setState({student_Message : "No Content!"});
        }else{
          this.setState({student_Message : this.state.dateList[i][this.state.checkpoint.Instructor]});
        }
      }else{
        if(this.state.dateList[i][this.state.checkpoint.Instructor] === ""){
          this.setState({student_Message : this.state.dateList[i].All });
        }else{
          this.setState({student_Message : this.state.dateList[i].All + this.state.dateList[i][this.state.checkpoint.Instructor] });
        }
      }
      break;
    }
  }
});
  }

  login(){
    //console.log("sign-in");
    //This code will setup the Google login page
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithRedirect(provider);
    //console.log(this.state.currentpage);
  }

  logout() {
    //This will sign out of firebase authentication and set
    //the user variable to null
    firebase.auth().signOut().then(() => {
      this.setState({
        user: null
      });
    });
    //(this.state.currentpage + "hello");
  }

  showMenuPage(){
    if(this.state.currentpage === "Login"){
      return(
        <div>
            <MuiThemeProvider>
              <div className="mainTitle">
                <AppBar
                    title= 'MVHS Locker Room App'
                    onLeftIconButtonClick={this.handleDrawerClick.bind()}
                    style={
                    {
                      background:"#ffb400" //hex color values
                    }
                  }
                  titleStyle = {
                  {
                    color:"#212121"
                  }
                }
                />
              <h4>
                <Drawer open={this.state.open}>
                  <MenuItem onClick={this.handleMenuLogin.bind()}>Sign In</MenuItem>
                  <MenuItem onClick={this.handleMenuInfo.bind()}>Info</MenuItem>
                </Drawer>
              </h4>
            </div>
            </MuiThemeProvider>
          {this.menuControl()}
          <br /><br />
          <MuiThemeProvider>
            <center><FlatButton label="Login with Google Account"
              onClick={this.login}
              style={
              {
                backgroundColor:"#ffb400" //hex color values
              }
            }
          /></center>
        </MuiThemeProvider>
        <br />
        </div>
      );
    }else{
      return(
        <div>
          <MuiThemeProvider>
            <div className="mainTitle">
              <AppBar
                  title= 'MVHS Locker Room App'
                  onLeftIconButtonClick={this.handleDrawerClick.bind()}
                  style={
                  {
                    background:"#ffb400" //hex color values
                  }
                }
                titleStyle = {
                {
                  color:"#FFFFF"
                }
              }
              />
            <Drawer open={this.state.open}>
              <MenuItem onClick={this.handleMenuLogin.bind()}>Sign In</MenuItem>
              <MenuItem onClick={this.handleMenuInfo.bind()}>Info</MenuItem>
            </Drawer>
          </div>
          </MuiThemeProvider>
          {this.menuControl()}
        </div>
      );
    }
  }

  showStudentLoginPage(){
    const actions = [
      <FlatButton
        label="No"
        primary={true}
        onClick={this.handleClose.bind(this, 0)}
      />,
      <FlatButton
        label="Yes"
        primary={true}
        keyboardFocused={true}
        onClick={this.handleClose.bind(this, 1)}
      />,
    ];

    const actions2 = [
      <FlatButton
        label="No,let me check again"
        secondary={true}
        onClick={this.handleClose.bind(this, 2)}
      />,
      <FlatButton
        label="Yes, I'm sure"
        primary={true}
        keyboardFocused={true}
        onClick={this.handleClose.bind(this, 3)}
      />,
    ];

    const actions3 = [
      <FlatButton
        label="Leave"
        secondary={true}
        onClick={this.logout}
      />,
      <FlatButton
        label="Stay"
        primary={true}
        keyboardFocused={true}
        onClick={this.handleClose.bind(this, 4)}
      />,
    ];


    if(!this.state.Initialize){
      return(
        <div>
          <h1> Student Account </h1>
          <br/><br/>
          <center><h2>Welcome! {this.state.user.displayName}</h2></center>
          <br/><br/>
          <center><p>Are you a student of Mountain View Hign school?</p></center>
          <br/><br/><br/>
          <MuiThemeProvider>
            <div>
              <center>
              <RaisedButton label="Yes, I am"
                onClick={this.handleOpen}
                style={
                  {
                    backgroundColor: "#00000",//hex color values
                  }
                }
                /></center><br/><br/><br/>

              <center><RaisedButton label="No, I'm not." onClick={this.logout}
                style={
                  {
                    backgroundColor: "#ffb400",//hex color values
                  }
                }
              /></center>
            </div>
          </MuiThemeProvider>

          <MuiThemeProvider>
            <div>
              <Dialog
                title="Confirmation Message"
                actions={actions}
                modal={false}
                open={this.state.openD1}
                onRequestClose={this.handleClose}
              >
              Do you wish to sign up for a locker right now?
              </Dialog>
            </div>
          </MuiThemeProvider>

        </div>
      );
    }
    else{
      const items = [
        <MenuItem key={1} value={1} primaryText="Boy" />,
        <MenuItem key={2} value={2} primaryText="Girl" />,
      ];

      const styles = {
        underlineStyle: {
          borderColor: blue500,
        },
      };
      return(
        <div>
          <div className="bottom">
            <MuiThemeProvider>
              <center>
                <div style={{width: '100%', maxWidth: 500, margin: 'auto'}}>
                      <SelectField
                        floatingLabelText="Choose the locker room"
                        floatingLabelStyle={{left: '0'}}
                        value={this.state.value2}
                        onChange={this.handleRoom}
                        errorText={this.state.StudentErrorText_Room}
                        underlineFocusStyle={styles.underlineStyle}
                        underlineStyle={styles.underlineStyle}
                      >
                        {items}
                      </SelectField>

                      <TextField
                        hintText="Only Enter The Number (Ex: 10)"
                        floatingLabelText="Current Grade"
                        errorText={this.state.StudentErrorText}
                        type="text"
                        onChange={this.handleGrade}
                        underlineFocusStyle={styles.underlineStyle}
                        underlineStyle={styles.underlineStyle}
                      />

                      <TextField
                        hintText="Only Enter The Number (Ex: 2)"
                        floatingLabelText="PE Class Period"
                        errorText={this.state.StudentErrorText_Period}
                        type="text"
                        onChange={this.handlePeriod}
                        underlineFocusStyle={styles.underlineStyle}
                        underlineStyle={styles.underlineStyle}
                      />

                      <TextField
                        hintText="Student's ID (5 digits number)"
                        floatingLabelText="Student ID"
                        errorText={this.state.StudentErrorText_ID}
                        type="text"
                        onChange={this.handleID}
                        underlineFocusStyle={styles.underlineStyle}
                        underlineStyle={styles.underlineStyle}
                      />

                      <SelectField
                        floatingLabelText="Instructor"
                        floatingLabelStyle={{left: '0'}}
                        value={this.state.value}
                        onChange={this.handleInstructor}
                        errorText={this.state.Student_Instructor !== "" ? '' : 'This field is required'}
                        labelStyle={styles.labelStyle}
                        underlineFocusStyle={styles.underlineStyle}
                        underlineStyle={styles.underlineStyle}
                      >

                      <MenuItem value={1} primaryText="Tami Kittle" />
                      <MenuItem value={2} primaryText="John Payne" />
                      <MenuItem value={3} primaryText="Shelley Smith" />
                      <MenuItem value={4} primaryText="Rick Esparza" />
                      <MenuItem value={5} primaryText="Julie Williams" />
                      <MenuItem value={6} primaryText="Kirk Jennings" />
                      <MenuItem value={7} primaryText="Todd Pearson" />
                      </SelectField>

                      <TextField
                        hintText="Just enter the number (Ex: 024)"
                        floatingLabelText="Choose a Locker Number"
                        errorText={this.state.StudentErrorText_Locker}
                        type="text"
                        onChange={this.handleLocker}
                        underlineFocusStyle={styles.underlineStyle}
                        underlineStyle={styles.underlineStyle}
                      />

                      <TextField
                        hintText="Identification Code Of The Lock"
                        floatingLabelText="Lock Series Number"
                        errorText={this.state.StudentErrorText_Series}
                        type="text"
                        onChange={this.handleSeris}
                        underlineFocusStyle={styles.underlineStyle}
                        underlineStyle={styles.underlineStyle}
                      />

                      <TextField
                        hintText="full combinations (Ex: 'XX-XX-XX')"
                        floatingLabelText="Passcode of your lock"
                        errorText={this.state.StudentErrorText_Code}
                        type="text"
                        onChange={this.handleCode}
                        underlineFocusStyle={styles.underlineStyle}
                        underlineStyle={styles.underlineStyle}
                      />

                      <div style={{marginTop: 12}}>
                      <FlatButton
                        label="Return to Main Menu"
                        disabled={false}
                        onClick={this.handleCheck}
                        style={{marginRight: 12}}
                      />
                      <RaisedButton
                        label={"Submit"}
                        primary={true}
                        onClick={this.handleNext}
                      />
                    </div>
                    <Snackbar
                      open={this.state.Warning}
                      message="Please Fill Out All The Information Correctly"
                      autoHideDuration={4000}
                      onRequestClose={this.handleRequestClose}
                    />

                    <Dialog
                        title="Confirmation Message"
                        actions={actions2}
                        modal={false}
                        open={this.CheckFullFilled() ? this.state.openD2 : false}
                        onRequestClose={this.handleClose}
                      >
                    Are you sure you put all your informations correctly?
                  </Dialog>

                  <Dialog
                    title="Do you wish to go back to the menu page?"
                    actions={actions3}
                    modal={false}
                    open={this.state.openD3}
                    onRequestClose={this.handleClose}
                  >
                  Your progress will not be saved!
                  </Dialog>

                </div>
              </center>
            </MuiThemeProvider>
          </div>
        </div>
      );
    }
  }

  isSelected = (index) => {
    return this.state.selected.indexOf(index) !== -1;
  };


  handleRowSelection = (selectedRows) => {
    this.setState({
      selected: selectedRows,
    });
    //console.log(this.state.selected)
  };


  showAdminSearch(){
    if(this.state.selectedSearch === 1){
      return(
        <div>
          <MuiThemeProvider>
            <Table className="table"
              height={800}
              fixedHeader={true}
              fixedFooter={true}
              selectable={true}
              multiSelectable={false}
            >
              <TableHeader
                displaySelectAll={false}
                adjustForCheckbox={true}
                enableSelectAll={false}
              >
                <TableRow>
                  <TableHeaderColumn colSpan="3" tooltip="Super Header" style={{textAlign: 'center' ,fontSize: '25px', color: '#212121',height: "50px"}}>
                    All Students Informations
                  </TableHeaderColumn>
                </TableRow>
                <TableRow>
                  <TableHeaderColumn tooltip="The ID">Student ID</TableHeaderColumn>
                  <TableHeaderColumn tooltip="The Name">Student Name</TableHeaderColumn>
                  <TableHeaderColumn tooltip="The Grade">Current Grade</TableHeaderColumn>
                  <TableHeaderColumn tooltip="The Instructor">Instructor</TableHeaderColumn>
                  <TableHeaderColumn tooltip="The Period">Period</TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody
                displayRowCheckbox={true}
                deselectOnClickaway={false}
                showRowHover={true}
                stripedRows={true}
              >

                {this.state.studentList.map( (item, index) => (
                  <TableRow >
                    <TableRowColumn>{item.ID}</TableRowColumn>
                    <TableRowColumn>{item.FirstName + " " + item.LastName}</TableRowColumn>
                    <TableRowColumn>{item.Grade}</TableRowColumn>
                    <TableRowColumn>{item.Instructor}</TableRowColumn>
                    <TableRowColumn>{item.Period}</TableRowColumn>
                  </TableRow>
                  ))}
              </TableBody>

            </Table>
          </MuiThemeProvider>
        </div>
      );
    }
    else if(this.state.selectedSearch === 2){
      return(
        <div>
         <MuiThemeProvider>
          <div>
            <br />
           <center><Paper transitionEnabled={false} style={
              {
                overflow: 'auto',
                display: 'inline-block',
                height: 100,
                width: "75%",
                background: "gary",
              }
              } zDepth={1}
                rounded={true}
                >

                <TextField
                style={
									{
										marginTop: '0px',

									}
								}

                  hintText="Student's firstname"
                  floatingLabelText="FirstName"
                  type="text"
                  onChange={this.handleSearchFirstname}
                  value={this.state.Search_Student_First}
                />

                <TextField
                style={
									{
										marginLeft: '10px',

									}
								}

                  hintText="Student's lastname"
                  floatingLabelText="Last Name"
                  type="text"
                  onChange={this.handleSearchLastname}
                  value={this.state.Search_Student_Last}
                />

                <FlatButton label="Search"
								onClick={(event) => this.SearchByName(event)}
								style={
									{
										backgroundColor: "#ffb400",//hex color values
										marginLeft: '10px',

									}
								}
							/>

              <FlatButton label="View Student"
								onClick={(event) => this.handleViewClick(event,1)}
								style={
									{
										backgroundColor: "#ffb400",//hex color values
										marginLeft: '10px',

									}
								}
							/>
              </Paper></center>
              <br />
              {this.drawTable(1)}


            </div>
          </MuiThemeProvider>
          {this.showInformationDialog()}
        </div>
      );
    }
    else if(this.state.selectedSearch === 3){
      return(
        <div>
         <MuiThemeProvider>
          <div>
            <br />
           <center><Paper transitionEnabled={false} style={
              {
                overflow: 'auto',
                display: 'inline-block',
                height: 100,
                width: "75%",
                background: "gary",
              }
              } zDepth={1}
                rounded={true}
                >

                <TextField
                style={
									{
										marginLeft: '10px',

									}
								}

                  hintText="Student's 5 digits ID"
                  floatingLabelText="Student ID"
                  type="text"
                  onChange={this.handleSearchID}
                  value={this.state.Search_Student_ID}
                />

                <FlatButton label="Search"
								onClick={(event) => this.SearchByID(event)}
								style={
									{
										backgroundColor: "#ffb400",//hex color values
										marginLeft: '10px',

									}
								}
							/>

              <FlatButton label="View Student"
								onClick={(event) => this.handleViewClick(event, 2)}
								style={
									{
										backgroundColor: "#ffb400",//hex color values
										marginLeft: '10px',

									}
								}
							/>
              </Paper></center>
              <br />
              {this.drawTable(2)}


            </div>
          </MuiThemeProvider>
          {this.showInformationDialog()}
        </div>
      );
    }
    else if(this.state.selectedSearch === 4){
      return(
        <div>
         <MuiThemeProvider>
          <div>
            <br />
           <center><Paper transitionEnabled={false} style={
              {
                overflow: 'auto',
                display: 'inline-block',
                height: 100,
                width: "75%",
                background: "gary",
              }
              } zDepth={2}
                rounded={true}
                >

                <TextField
                style={
									{
										marginLeft: '10px',

									}
								}

                  hintText="3 digits Locker Number"
                  floatingLabelText="Locker Number"
                  type="text"
                  onChange={this.handleSearchLocker}
                  value={this.state.Search_Student_Locker}
                />

                <FlatButton label="Search"
								onClick={(event) => this.SearchByLocker(event)}
								style={
									{
										backgroundColor: "#ffb400",//hex color values
										marginLeft: '10px',

									}
								}
							/>

              <FlatButton label="View Student"
								onClick={(event) => this.handleViewClick(event, 3)}
								style={
									{
										backgroundColor: "#ffb400",//hex color values
										marginLeft: '10px',

									}
								}
							/>
              </Paper></center>
              <br />
              {this.drawTable(3)}


            </div>
          </MuiThemeProvider>

          {this.showInformationDialog()}
        </div>
      );
    }
    else if(this.state.selectedSearch === 5){
      return(
       <div>
         <MuiThemeProvider>
          <div>
            <br />
           <center><Paper transitionEnabled={false} style={
              {
                overflow: 'auto',
                display: 'inline-block',
                height: 100,
                width: "75%",
                background: "gary",
              }
              } zDepth={2}
                rounded={true}
                >

                <TextField
                  hintText="Student's PE Class Period"
                  floatingLabelText="Class Period"
                  type="text"
                  onChange={this.handleSearchPeriod}
                  value={this.state.Search_Student_Period}
                />

                <SelectField className="pinned"
                  style={
									{
										marginLeft: '10px',
                    marginTop: '5px',

									}
								}
                  floatingLabelText="Instructor"
                  value={this.state.value}
                  onChange={this.handleInstructor}
                  labelStyle={styles.labelStyle}
                >
                  <MenuItem value={0} primaryText="" />
                  <MenuItem value={1} primaryText="Tami Kittle" />
                  <MenuItem value={2} primaryText="John Payne" />
                  <MenuItem value={3} primaryText="Shelley Smith" />
                  <MenuItem value={4} primaryText="Rick Esparza" />
                  <MenuItem value={5} primaryText="Julie Williams" />
                  <MenuItem value={6} primaryText="Kirk Jennings" />
                  <MenuItem value={7} primaryText="Todd Pearson" />

                </SelectField>

                <FlatButton label="Search"
								onClick={(event) => this.SearchByPeriod(event)}
								style={
									{
										backgroundColor: "#ffb400",//hex color values
										marginLeft: '10px',
                    marginTop: '1px',

									}
								}
							/>

              <FlatButton label="View Student"
								onClick={(event) => this.handleViewClick(event, 4)}
								style={
									{
										backgroundColor: "#ffb400",//hex color values
										marginLeft: '10px',
										marginTop: '1px',
									}
								}
							/>
              </Paper></center>
              <br />
              {this.drawTable(4)}



            </div>
          </MuiThemeProvider>
          {this.showInformationDialog()}
        </div>
      );
    }
    else if(this.state.selectedSearch === 6){
      return(
        <div>
          <MuiThemeProvider>
            <div>
                <Table onRowSelection={this.handleRowSelection}
                  height={window.innerHeight*0.70}
                  fixedHeader={true}
                  fixedFooter={true}
                  selectable={true}
                  multiSelectable={true}
                >
                  <TableHeader
                    displaySelectAll={true}
                    adjustForCheckbox={true}
                    enableSelectAll={true}
                  >
                    <TableRow>
                      <TableHeaderColumn colSpan="3" tooltip="Super Header" style={{textAlign: 'center' ,fontSize: '25px', color: '#212121',height: "50px"}}>
                        Student Waiting List
                      </TableHeaderColumn>
                    </TableRow>
                    <TableRow>
                      <TableHeaderColumn tooltip="The ID">Student ID</TableHeaderColumn>
                      <TableHeaderColumn tooltip="The Name">Student Name</TableHeaderColumn>
                      <TableHeaderColumn tooltip="The Grade">Current Grade</TableHeaderColumn>
                      <TableHeaderColumn tooltip="The Instructor">Instructor</TableHeaderColumn>
                      <TableHeaderColumn tooltip="The Period">Period</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>

                    <TableBody
                      displayRowCheckbox={true}
                      deselectOnClickaway={false}
                      showRowHover={true}
                      stripedRows={true}
                    >

                      {this.state.PrestudentList.map( (item, index) => (
                        <TableRow selected={this.isSelected(index)}>
                          <TableRowColumn>{item.ID}</TableRowColumn>
                          <TableRowColumn>{item.FirstName + " " + item.LastName}</TableRowColumn>
                          <TableRowColumn>{item.Grade}</TableRowColumn>
                          <TableRowColumn>{item.Instructor}</TableRowColumn>
                          <TableRowColumn>{item.Period}</TableRowColumn>
                        </TableRow>
                      ))}
                    </TableBody>

                </Table>
              <br /><br />
              <center><Paper transitionEnabled={true} className="approve-1" style={
              {
                overflow: 'auto',
                display: 'inline-block',
                width: "70%",
                background: "gary",
              }
            } zDepth={2}
                rounded={true}
                >
                <FlatButton label="approve"
								onClick={(event) => this.handleProveClick(event)}
								style={
									{
										backgroundColor: "#ffb400",//hex color values
										margin: '10px',

									}
								}
							/>

              <FlatButton label="remove"
              onClick={(event) => this.handleRemoveClick(event)}
              style={
                {
                  backgroundColor: "#ffb400",//hex color values
                  margin: '10px',

                }
              }
            />

              </Paper></center>
            </div>
          </MuiThemeProvider>

        </div>
      );
    }
    else if(this.state.selectedSearch === 7){
      const style = {
        position: 'fixed',
        textAlign: 'center',
        display: 'inline-block',
        fontSize: 24,
      };


      const message = "mailto:" + "allengaosh@icloud.com";
      return(
        <div>
          <MuiThemeProvider>
            <Paper className="center-1"
            style={style}
            zDepth={3}>
              Please Press The Button Below To Report Any Bugs Or Advices Of This App
              <br /><br /><br />

              <RaisedButton className="contact-1" label="Contact Me" primary={true} href={message}/>
            </Paper>
          </MuiThemeProvider>
        </div>
      );
    }
    else if(this.state.selectedSearch === 8){
      const style1 = {
        position: 'fixed',
        textAlign: 'center',
        display: 'inline-block',
        fontSize: 24,
      };
      return(
        <div>
          <MuiThemeProvider>
          <center><Paper transitionEnabled={true} style={
             {
               overflow: 'auto',
               display: 'inline-block',
               height: 120,
               width: "75%",
             }
             } zDepth={2}
               rounded={true}
               >

               <TextField
                 hintText="Identification Code Of The Lock"
                 floatingLabelText="Lock Series Number"
                 type="text"
                 onChange={this.handleSeris}
               />

               <FlatButton label="Search" className="SearchMatch"
               onClick={(event) => this.SearchSeriesMatch(event)}
               style={
                 {
                   backgroundColor: "#ffb400",//hex color values
                   marginLeft: '10px',
                   marginTop: '20px',
                 }
               }
             />
             </Paper></center>
          </MuiThemeProvider>
          <MuiThemeProvider>
            <Paper className="center-2"
              style={style1}
              zDepth={4}
              transitionEnabled={true}
            >
              <h1>{this.state.output_Combination}</h1>
              <h2>{this.state.ouput_Owner}</h2>
            </Paper>
          </MuiThemeProvider>
        </div>
      );
    }
    else if(this.state.selectedSearch === 9){
      const style = {
        position: 'fixed',
        textAlign: 'center',
        display: 'inline-block',
        fontSize: 24,
      };
      const style2 = {
        position: 'fixed',
        textAlign: 'top',
        display: 'inline-block',
        fontSize: 24,
      };
      return(
        <div>
          <MuiThemeProvider>
            <Paper style={style} zDepth={4} className="center-3" autoScrollBodyContent={true}>
               <DatePicker
                hintText="Choose a Date"
                mode="landscape"
                value={this.state.controlledDate}
                onChange={this.handleChangeDate}
              />

               <SelectField
                 floatingLabelText="Select the Instructor"
                 floatingLabelStyle={{color: 'grey', left: "0px"}}
                 value={this.state.value}
                 onChange={this.handleInstructor}
               >
                 <MenuItem value={1} primaryText="Tami Kittle" />
                 <MenuItem value={2} primaryText="John Payne" />
                 <MenuItem value={3} primaryText="Shelley Smith" />
                 <MenuItem value={4} primaryText="Rick Esparza" />
                 <MenuItem value={5} primaryText="Julie Williams" />
                <MenuItem value={6} primaryText="Kirk Jennings" />
                <MenuItem value={7} primaryText="Todd Pearson" />
                 <MenuItem value={8} primaryText="Send to all classes" />
               </SelectField>

               <FlatButton
                  label="Submit"
                  className="upright-1"
                  onClick={(event) => this.handleInfo()}
                  style={
                  {
                    position: "auto",
                    backgroundColor:"#ffb400", //hex color values

                  }
                }
                />
            </Paper>

            <Snackbar
              open={this.state.openWarn}
              message="Please Input the Date and Instructor"
              autoHideDuration={4000}
              onRequestClose={this.handleRequestClose2}
            />

            <Paper style={style2} zDepth={1} className="field-1">
              <center><h2>Daily Announcement: </h2></center>
              <Divider inset={true} />
                <br />
              <center><a>{this.showAnn2(this.state.dailynote)}</a></center>
            </Paper>

            {this.addIn()}
          </MuiThemeProvider>
        </div>
      );
    }
    else if(this.state.selectedSearch === 10){
      const style = {
        position: 'fixed',
        textAlign: 'center',
        display: 'inline-block',
        fontSize: 24,
      };

      const actions = [
        <FlatButton
          label="Cancel"
          secondary={true}
          keyboardFocused={true}
          onClick={(event) => this.handleClose(5)}
        />,
        <FlatButton
          label="Confirm"
          primary={true}
          keyboardFocused={true}
          onClick={this.handleSearchClose3}
        />,
      ];

      return(
        <div>
          <MuiThemeProvider>
            <Paper className="center-1"
            style={style}
            zDepth={3}>
              Press The Button Below To Delete All Current Students
              <br /><br /><br />

              <RaisedButton className="contact-1" label="Delete All" primary={true} onClick={this.handleOpen} />
            </Paper>
          </MuiThemeProvider>

          <MuiThemeProvider>
            <div>
              <Dialog
                title="Confirmation Message"
                actions={actions}
                modal={false}
                open={this.state.openD1}
                onRequestClose={this.handleClose}
              >
              Are you sure to delete all current students?
              </Dialog>
            </div>
          </MuiThemeProvider>

        </div>
      );
    }

  }

  showAnn2(input){
    if(input !== ""){
      if(input === "No Content!"){
        return(
          <h2>No content!</h2>
        );
      }else{
        var res = input.substring(0,input.length-3).split("///");
        return(
          <div>
            {res.map( (item) =>  <li>{item}</li>)}
          </div>
        );
      }
    }else{
      return(
        null
      );
    }
  }

  addIn(){
    if(this.state.Datecheck){
      const style2 = {
        position: 'fixed',
        textAlign: 'top',
        display: 'inline-block',
        fontSize: 24,
      };
      return(
        <MuiThemeProvider>
          <Paper style={style2} zDepth={2} className="field-3">
            <TextField
              hintText="Enter the Announcement..."
              floatingLabelText="Daily Announcement"
              multiLine={true}
              fullWidth={true}
              rowsMax={6}
              rows={2}
              onChange={this.handleNote}
            />
            <FlatButton label="Add"
              onClick={(event) => this.AddDate(1)}
              className="button-1"
              style={{backgroundColor:"#ffb400",}}
            />

            <FlatButton label="Replace"
              onClick={(event) => this.AddDate(2)}
              className="button-2"
              style={{backgroundColor:"#ffb400",}}
            />
          </Paper>
        </MuiThemeProvider>
      );
    }else{
      return(null);
    }
  }

  AddDate(mode){
    let current = this.state.controlledDate.toString().substring(0,15);
    let newDate = {};
    for(let i = 0; i < this.state.dateList.length; i++){
      if(this.state.dateList[i].date === current){
        newDate = this.state.dateList[i];
      }
    }
    if(mode === 1){
      const DateListDB = firebase.database().ref("Date/"+current);

      if(this.state.added_note !== ""){
        newDate[this.state.Student_Instructor] += this.state.added_note + " (" + this.state.user.displayName + ")///";
      }else{
        newDate[this.state.Student_Instructor] = newDate[this.state.Student_Instructor];
      }
      //Add a value to the firebase
      DateListDB.set(
        newDate
      );
      this.UpdateAdminList();
      this.handleInfo();
    }else if(mode === 2){
      const DateListDB = firebase.database().ref("Date/"+current);
      if(this.state.added_note !== ""){
        newDate[this.state.Student_Instructor] = this.state.added_note + " (" + this.state.user.displayName + ")///";
      }else{
        newDate[this.state.Student_Instructor] = "";
      }
      //Add a value to the firebase
      DateListDB.set(
        newDate
      );
      this.UpdateAdminList();
      this.handleInfo();
    }
  }

  handleNote = (event, value) => {
      this.setState({ added_note: value});
	}
//////////////////////////////////////
  handleInfo = (event) => {
    if(this.state.controlledDate !== null && this.state.Student_Instructor !== ""){
        var date = this.state.controlledDate.toString().substring(0,15)
        const DateListDB = firebase.database().ref("Date");
        let check = false;
        let item = {};
        let note = "";

        for(let i = 0; i < this.state.dateList.length; i++){
          if(this.state.dateList[i].date === date){
            check = true;
            item = this.state.dateList[i]
          }
        }
      if(check){
        if(item[this.state.Student_Instructor] !== "" ){
          this.setState({Announcement: item, dailynote: item[this.state.Student_Instructor],Datecheck : true})
        }else{
          this.setState({Announcement: item, dailynote: "No Content!",Datecheck : true})
        }
      }else{
        //create a new date in firebase
        let input = this.state.controlledDate.toString().substring(0,15);
        const DateListDB = firebase.database().ref("Date/" + input);

        const newDate = {
            date : input,
            John : "",
            Julie : "",
            Rick : "",
            Shelley : "",
            Tami : "",
            Kirk : "",
            Todd: "",
            All : "",
        }

        //Add a value to the firebase
        DateListDB.set(
          newDate
        );
        this.UpdateAdminList();
        this.setState({Announcement: newDate, dailynote: "No Content!", Datecheck : true})
      }
    }else{
      this.setState({openWarn: true})
    }
  }
////////////////////////////////////////////////
  handleChangeDate = (event, date) => {
    this.setState({
      controlledDate: date,
    });
  };

  handleRequestClose2 = () => {
    this.setState({
      openWarn: false,
    });
  };

  showInformationDialog(){
    const actions = [
      <FlatButton
        label="Remove"
        secondary={true}
        keyboardFocused={true}
        onClick={this.handleSearchClose2}
      />,
      <FlatButton
        label="Ok"
        primary={true}
        keyboardFocused={true}
        onClick={this.handleSearchClose1}
      />,
    ];

    const actionID = [
      <FlatButton
        label="Cancel"
        secondary={true}
        onClick={this.handleCloseUpdate.bind(this, 1)}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        keyboardFocused={true}
        onClick={this.handleSubmitUpdate.bind(this, 1)}
      />,
    ];

    const actionLockerNumber = [
      <FlatButton
        label="Cancel"
        secondary={true}
        onClick={this.handleCloseUpdate.bind(this, 2)}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        keyboardFocused={true}
        onClick={this.handleSubmitUpdate.bind(this, 2)}
      />,
    ];

    const actionLockNumber = [
      <FlatButton
        label="Cancel"
        secondary={true}
        onClick={this.handleCloseUpdate.bind(this, 3)}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        keyboardFocused={true}
        onClick={this.handleSubmitUpdate.bind(this, 3)}
      />,
    ];

    const actionCode = [
      <FlatButton
        label="Cancel"
        secondary={true}
        onClick={this.handleCloseUpdate.bind(this, 4)}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        keyboardFocused={true}
        onClick={this.handleSubmitUpdate.bind(this, 4)}
      />,
    ];

    const actionGrade = [
      <FlatButton
        label="Cancel"
        secondary={true}
        onClick={this.handleCloseUpdate.bind(this, 5)}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        keyboardFocused={true}
        onClick={this.handleSubmitUpdate.bind(this, 5)}
      />,
    ];

    const actionPeriod = [
      <FlatButton
        label="Cancel"
        secondary={true}
        onClick={this.handleCloseUpdate.bind(this, 7)}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        keyboardFocused={true}
        onClick={this.handleSubmitUpdate.bind(this, 7)}
      />,
    ];

    const actionInstructor = [
      <FlatButton
        label="Cancel"
        secondary={true}
        onClick={this.handleCloseUpdate.bind(this, 6)}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        keyboardFocused={true}
        onClick={this.handleSubmitUpdate.bind(this, 6)}
      />,
    ];

    return (
      <div>
        <MuiThemeProvider>
          <Dialog
          title="Student Information"
          actions={actions}
          modal={false}
          open={this.state.openSearch}
          onRequestClose={this.handleSearchClose1}
          autoScrollBodyContent={true}
        >
          <ListItem disabled={true} secondaryText= {"LockerRoom: " + this.state.LockerRoom}/>
          <ListItem disabled={true} secondaryText= {"FirstName: " + this.state.FirstName}/>
          <ListItem disabled={true} secondaryText= {"LastName: " + this.state.LastName}/>
          <ListItem disabled={false} primaryText= {"Student ID: " + this.state.ID} onClick={(event) => this.handleUpdateID()}/>
          <ListItem disabled={true} secondaryText= {"Email: " + this.state.Email}/>
          <ListItem disabled={false} primaryText= {"Locker Number: " + this.state.LockerNumber} onClick={(event) => this.handleUpdateLockerNumber()}/>
          <ListItem disabled={false} primaryText= {"Seris Number: " + this.state.LockNumber} onClick={(event) => this.handleUpdateLockNumber()}/>
          <ListItem disabled={false} primaryText= {"Lock Combination: " + this.state.PassCode} onClick={(event) => this.handleUpdateCode()}/>
          <ListItem disabled={false} primaryText= {"Grade: " + this.state.Grade} onClick={(event) => this.handleUpdateGrade()}/>
          <ListItem disabled={false} primaryText= {"Instructor: " + this.state.Instructor} onClick={(event) => this.handleUpdateInstructor()}/>
          <ListItem disabled={false} primaryText= {"Period: " + this.state.Period} onClick={(event) => this.handleUpdatePeriod()}/>
          <ListItem disabled={true} secondaryText= {"Active Mode: " + this.state.Active}/>
        </Dialog>

        <Dialog
          title="Update Student ID"
          actions={actionID}
          modal={false}
          open={this.state.openUpdateID}
          onRequestClose={this.handleCloseUpdate.bind(this, 1)}
        >
          Put the new Student ID in the text field below
          <br /><br />
          <TextField
            hintText="Student's ID (5 digits number)"
            floatingLabelText="Student ID"
            errorText={this.state.StudentErrorText_ID}
            type="text"
            onChange={this.handleID}
          />
        </Dialog>

        <Dialog
          title="Update Student's Locker Number"
          actions={actionLockerNumber}
          modal={false}
          open={this.state.openUpdateLockerNumber}
          onRequestClose={this.handleCloseUpdate.bind(this, 2)}
        >
          Put the new Locker Number in the text field below
          <br /><br />
          <TextField
            hintText="Just enter the number (Ex: 024)"
            floatingLabelText="Choose a Locker Number"
            errorText={this.state.StudentErrorText_Locker}
            type="text"
            onChange={this.handleLocker}
          />
        </Dialog>

        <Dialog
          title="Update Student's Series Number"
          actions={actionLockNumber}
          modal={false}
          open={this.state.openUpdateLockNumber}
          onRequestClose={this.handleCloseUpdate.bind(this, 3)}
        >
          Put the new Series Number in the text field below
          <br /><br />
          <TextField
            hintText="Identification Code Of The Lock"
            floatingLabelText="Input Series Number"
            errorText={this.state.StudentErrorText_Series}
            type="text"
            onChange={this.handleSeris}
          />
        </Dialog>

        <Dialog
          title="Update Student's PassCode"
          actions={actionCode}
          modal={false}
          open={this.state.openUpdateCode}
          onRequestClose={this.handleCloseUpdate.bind(this, 4)}
        >
          Put the new Pass Code in the text field below
          <br /><br />
          <TextField
            hintText="full combinations (Ex: 'XX-XX-XX')"
            floatingLabelText="Passcode of the lock"
            errorText={this.state.StudentErrorText_Code}
            type="text"
            onChange={this.handleCode}
          />
        </Dialog>

        <Dialog
          title="Update Student's Grade"
          actions={actionGrade}
          modal={false}
          open={this.state.openUpdateGrade}
          onRequestClose={this.handleCloseUpdate.bind(this, 5)}
        >
          Put the new Grade Information in text field below
          <br /><br />
          <TextField
            hintText="Only Enter The Number (Ex: 10)"
            floatingLabelText="Student's Grade"
            errorText={this.state.StudentErrorText}
            type="text"
            onChange={this.handleGrade}
          />
        </Dialog>

        <Dialog
          title="Update Student's Instructor"
          actions={actionInstructor}
          modal={false}
          open={this.state.openUpdateInstructor}
          onRequestClose={this.handleCloseUpdate.bind(this, 6)}
        >
          Select the new Instructor Information in text field below
          <br /><br />
          <SelectField
            floatingLabelText="Instructor"
            value={this.state.value}
            onChange={this.handleInstructor}
            errorText={this.state.Student_Instructor !== "" ? '' : 'This field is required'}
            labelStyle={styles.labelStyle}
          >
          <MenuItem value={1} primaryText="Tami Kittle" />
          <MenuItem value={2} primaryText="John Payne" />
          <MenuItem value={3} primaryText="Shelley Smith" />
          <MenuItem value={4} primaryText="Rick Esparza" />
          <MenuItem value={5} primaryText="Julie Williams" />
          <MenuItem value={6} primaryText="Kirk Jennings" />
          <MenuItem value={7} primaryText="Todd Pearson" />
          </SelectField>
        </Dialog>

        <Dialog
          title="Update Student's Period"
          actions={actionPeriod}
          modal={false}
          open={this.state.openUpdatePeriod}
          onRequestClose={this.handleCloseUpdate.bind(this, 7)}
        >
          Put the new Period Information in text field below
          <br /><br />
          <TextField
            hintText="Only Enter The Number (Ex: 2)"
            floatingLabelText="PE Class Period"
            errorText={this.state.StudentErrorText_Period}
            type="text"
            onChange={this.handlePeriod}
          />
        </Dialog>


        </MuiThemeProvider>
      </div>
    );
  }
/////////////////////////////////////////////
  handleUpdateID = (event) => {
    this.setState({openUpdateID: true});
  }

  handleUpdateLockerNumber = (event) => {
    this.setState({openUpdateLockerNumber: true});
  }

  handleUpdateLockNumber = (event) => {
    this.setState({openUpdateLockNumber: true});
  }

  handleUpdateCode = (event) => {
    this.setState({openUpdateCode: true});
  }

  handleUpdateGrade = (event) => {
    this.setState({openUpdateGrade: true});
  }
  handleUpdateInstructor = (event) => {
    this.setState({openUpdateInstructor: true});
  }

  handleUpdatePeriod = (event) => {
    this.setState({openUpdatePeriod: true});
  }
  ///////////////////////////////////////

  handleCloseUpdate(input){
    if(input === 1){
      this.setState({openUpdateID: false});
    }else if(input === 2){
      this.setState({openUpdateLockerNumber: false});
    }else if(input === 3){
      this.setState({openUpdateLockNumber: false});
    }else if(input === 4){
      this.setState({openUpdateCode: false});
    }else if(input === 5){
      this.setState({openUpdateGrade: false});
    }else if(input === 6){
      this.setState({openUpdateInstructor: false});
    }else if(input === 7){
      this.setState({openUpdatePeriod: false});
    }
  }

  handleSubmitUpdate(input){
    if(input === 1){
      //remove the old key
      if(this.state.StudentErrorText_ID === ''){
        const shoppingListDB = firebase.database().ref("Students");
        shoppingListDB.child(this.state.ID).remove();
        //add the new key
        const StudentListDB = firebase.database().ref("Students/" + this.state.Student_ID);

        const aStudent = {
            FirstName : this.state.FirstName,
            LastName : this.state.LastName,
            Email : this.state.Email,
            ID : this.state.Student_ID,
            LockerNumber : this.state.LockerNumber,
            LockNumber : this.state.LockNumber,
            PassCode: this.state.PassCode,
            LockerRoom: this.state.LockerRoom,
            Grade: this.state.Grade,
            Instructor: this.state.Instructor,
            Period: this.state.Period,
            Active: this.state.Active,
        }


        //Add a value to the new student to firebase
        StudentListDB.set(
          aStudent
        );
        this.UpdateAdminList();
        var text = this.state.Student_ID;
        this.setState({openUpdateID: false, StudentErrorText_ID: 'This field is required', Student_ID: '', ID: text });
      }
      else{
        alert("Please input the correct form");
        this.setState({openUpdateID: true});
      }
    }
    else if(input === 2){
      if(this.state.StudentErrorText_Locker === ''){
        //add the new key
        const StudentListDB = firebase.database().ref("Students/" + this.state.ID);

        const aStudent = {
            FirstName : this.state.FirstName,
            LastName : this.state.LastName,
            Email : this.state.Email,
            ID : this.state.ID,
            LockerNumber : this.state.Student_LockerNumber,
            LockNumber : this.state.LockNumber,
            LockerRoom: this.state.LockerRoom,
            PassCode: this.state.PassCode,
            Grade: this.state.Grade,
            Instructor: this.state.Instructor,
            Period: this.state.Period,
            Active: this.state.Active,
        }


        //Add a value to the new student to firebase
        StudentListDB.set(
          aStudent
        );
        this.UpdateAdminList();
        var number = this.state.Student_LockerNumber;
        this.setState({openUpdateLockerNumber: false, StudentErrorText_Locker: 'This field is required', Student_LockerNumber: '', LockerNumber: number});
      }
      else{
        alert("Please input the correct form");
        this.setState({openUpdateLockerNumber: true});
      }
    }
    else if(input === 3){
      if(this.state.StudentErrorText_Series === ''){
        //add the new key
        const StudentListDB = firebase.database().ref("Students/" + this.state.ID);

        const aStudent = {
            FirstName : this.state.FirstName,
            LastName : this.state.LastName,
            Email : this.state.Email,
            ID : this.state.ID,
            LockerNumber : this.state.LockerNumber,
            LockNumber : this.state.Student_SerisNumber,
            LockerRoom: this.state.LockerRoom,
            PassCode: this.state.PassCode,
            Grade: this.state.Grade,
            Instructor: this.state.Instructor,
            Period: this.state.Period,
            Active: this.state.Active,
        }


        //Add a value to the new student to firebase
        StudentListDB.set(
          aStudent
        );
        this.UpdateAdminList();
        var number = this.state.Student_SerisNumber;
        this.setState({openUpdateLockNumber: false, StudentErrorText_Series: 'This field is required', Student_SerisNumber: '', LockNumber: number});
      }
      else{
        alert("Please input the correct form");
        this.setState({openUpdateLockNumber: true});
      }
    }
    else if(input === 4){
      if(this.state.StudentErrorText_Code === ''){
        //add the new key
        const StudentListDB = firebase.database().ref("Students/" + this.state.ID);

        const aStudent = {
            FirstName : this.state.FirstName,
            LastName : this.state.LastName,
            Email : this.state.Email,
            ID : this.state.ID,
            LockerNumber : this.state.LockerNumber,
            LockNumber : this.state.LockNumber,
            PassCode: this.state.Student_LockCode,
            LockerRoom: this.state.LockerRoom,
            Grade: this.state.Grade,
            Instructor: this.state.Instructor,
            Period: this.state.Period,
            Active: this.state.Active,
        }


        //Add a value to the new student to firebase
        StudentListDB.set(
          aStudent
        );
        this.UpdateAdminList();
        var number = this.state.Student_LockCode;
        this.setState({openUpdateCode: false, StudentErrorText_Code: 'This field is required', Student_LockCode: '', PassCode: number});
      }
      else{
        alert("Please input the correct form");
        this.setState({openUpdateCode: true});
      }
    }
    else if(input === 5){
      if(this.state.StudentErrorText === ''){
        //add the new key
        const StudentListDB = firebase.database().ref("Students/" + this.state.ID);

        const aStudent = {
            FirstName : this.state.FirstName,
            LastName : this.state.LastName,
            Email : this.state.Email,
            ID : this.state.ID,
            LockerNumber : this.state.LockerNumber,
            LockNumber : this.state.LockNumber,
            LockerRoom: this.state.LockerRoom,
            PassCode: this.state.PassCode,
            Grade: this.state.Student_Grade,
            Instructor: this.state.Instructor,
            Period: this.state.Period,
            Active: this.state.Active,
        }


        //Add a value to the new student to firebase
        StudentListDB.set(
          aStudent
        );
        this.UpdateAdminList();
        var number = this.state.Student_Grade;
        this.setState({openUpdateGrade: false, StudentErrorText: 'This field is required', Student_Grade: '', Grade: number});
      }
      else{
        alert("Please input the correct form");
        this.setState({openUpdateGrade: true});
      }
    }
    else if(input === 6){
      if(this.state.Student_Instructor !== ''){
        //add the new key
        const StudentListDB = firebase.database().ref("Students/" + this.state.ID);

        const aStudent = {
            FirstName : this.state.FirstName,
            LastName : this.state.LastName,
            Email : this.state.Email,
            ID : this.state.ID,
            LockerNumber : this.state.LockerNumber,
            LockNumber : this.state.LockNumber,
            LockerRoom: this.state.LockerRoom,
            PassCode: this.state.PassCode,
            Grade: this.state.Grade,
            Instructor: this.state.Student_Instructor,
            Period: this.state.Period,
            Active: this.state.Active,
        }


        //Add a value to the new student to firebase
        StudentListDB.set(
          aStudent
        );
        this.UpdateAdminList();
        var number = this.state.Student_Instructor;
        this.setState({openUpdateInstructor: false,  Student_Instructor: '', Instructor: number});
      }
      else{
        alert("Please input the correct form");
        this.setState({openUpdateInstructor: true});
      }
    }
    else if(input === 7){
      if(this.state.StudentErrorText_Period === ''){
        //add the new key
        const StudentListDB = firebase.database().ref("Students/" + this.state.ID);

        const aStudent = {
            FirstName : this.state.FirstName,
            LastName : this.state.LastName,
            Email : this.state.Email,
            ID : this.state.ID,
            LockerNumber : this.state.LockerNumber,
            LockNumber : this.state.LockNumber,
            LockerRoom: this.state.LockerRoom,
            PassCode: this.state.PassCode,
            Grade: this.state.Grade,
            Instructor: this.state.Instructor,
            Period: this.state.Student_Period,
            Active: this.state.Active,
        }


        //Add a value to the new student to firebase
        StudentListDB.set(
          aStudent
        );
        this.UpdateAdminList();
        var number = this.state.Student_Period;
        this.setState({openUpdatePeriod: false, StudentErrorText_Period: 'This field is required', Student_Period: '', Period: number});
      }
      else{
        alert("Please input the correct form");
        this.setState({openUpdatePeriod: true});
      }
    }
  }
////////////////////////////////////////////
  showAdminLoginPage(){
    return (
          <div>
            <toolbar-1>
              <MuiThemeProvider>
                <Toolbar
                  style={
                  {
                    background:"#ffb400", //hex color values
                  }
                }
                >

                  <ToolbarGroup firstChild={true}>
                    <DropDownMenu value={this.state.MenuValue} onChange={this.handleMenuChange}>
                      <MenuItem value={1} primaryText="All Students" onClick={() => this.select(1)}/>
                      <MenuItem value={2} primaryText="Search By FirstName And LastName"  onClick={() => this.select(2)}/>
                      <MenuItem value={3} primaryText="Search By Student ID" onClick={() => this.select(3)} />
                      <MenuItem value={4} primaryText="Search By Locker Number" onClick={() => this.select(4)}/>
                      <MenuItem value={5} primaryText="Search By Period And Instructor" onClick={() => this.select(5)} />
                      <MenuItem value={6} primaryText="Seris Number (Match)" onClick={() => this.select(8)} />
                    </DropDownMenu>
                  </ToolbarGroup>

                 <ToolbarTitle text={"Admin Control Center" }
                                  style={styles.toolbarTextStyle}
                    />
                 <ToolbarGroup>
                    <ToolbarTitle text={"Hello, " + this.state.user.displayName }
                                  style={styles.toolbarTextStyle2}
                    />

                    {this.showNotice()}

                    <FontIcon className="muidocs-icon-custom-sort" />
                    <ToolbarSeparator />
                    <IconMenu
                      iconButtonElement={
                        <IconButton touch={true}>
                          <NavigationExpandMoreIcon />,
                        </IconButton>
                      }
                    >
                      <MenuItem primaryText="Log out"
                        onClick={this.logout}
                      />
                      <MenuItem primaryText="Announcement"
                        onClick={(event) => this.Announce()}
                      />
                      <MenuItem primaryText="Report a bug"
                        onClick={(event) => this.report()}
                      />
                      <MenuItem primaryText="Delete All Students"
                        onClick={(event) => this.DeleteAll()}
                      />
                    </IconMenu>
                  </ToolbarGroup>
                </Toolbar>
              </MuiThemeProvider>
              </toolbar-1>
              <admin-1>
              {this.showAdminSearch()}
              </admin-1>
          </div>
        );
      }

    report = (event) => {
      this.setState({selectedSearch: 7});
    }

    Announce = (event) => {
      this.setState({selectedSearch: 9});
    }

    DeleteAll = (event) => {
      this.setState({selectedSearch: 10});
    }

    showNotice(){
      if(this.state.PrestudentList.length !== 0){
        return(
          <Badge
            badgeContent={this.state.PrestudentList.length}
            secondary={true}
            badgeStyle={{top: 20, right: 1}}
        >
          <IconButton
            style={{top: -1, right: -12,}}
            onClick={() => this.select(6)}
          >
            <NotificationsIcon/>
          </IconButton>
        </Badge>
        );
      }
      else{
        return(
          <IconButton
            style={{top: -1, right: -12}}
            onClick={() => this.select(6)}
          >
            <NotificationsIcon/>
          </IconButton>
        );
      }
    }
    CheckID(){
      //console.log(this.state.adminList.length);
      for(var i = 0; i < this.state.adminList.length; i++){
        var name = this.state.adminList[i].firstname + " " + this.state.adminList[i].lastname;
        if (this.state.adminList[i].email === this.state.user.email) {
          return true;
        }
      }
      return false;
  }

  CheckStudentList(){
    for(var i = 0; i < this.state.studentList.length; i++){
        var name = this.state.studentList[i].FirstName + " " + this.state.studentList[i].LastName;
        if (this.state.studentList[i].Email === this.state.user.email) {
          return true;
        }
      }
      return false;
  }

  CheckPreStudentList(){
    for(var i = 0; i < this.state.PrestudentList.length; i++){
        var name = this.state.PrestudentList[i].FirstName + " " + this.state.PrestudentList[i].LastName;
        if (this.state.PrestudentList[i].Email === this.state.user.email) {
          return true;
        }
      }
      return false;
  }
  ///////////////////
  student_select = (index) => this.setState({selectedIndex: index});

  showStudentMenuPage(){
    const styles = {
      title: {
        cursor: 'pointer',
      },
    };
    const recentsIcon = <Info />;
    const favoritesIcon = <Announcement />;
    const nearbyIcon = <IconLocationOn />;

    return(
      <div>
        <MuiThemeProvider>
          <div>
            <AppBar
              className="student_title"
              style={{background:"#ffb400", fontSize: '10px',position: "fixed" }}
              titleStyle = {{color:"#EFEBE9"}}
              iconElementLeft={<h1>Welcome, {this.state.user.displayName}</h1>}
              iconElementRight={<IconButton tooltip="Logout" onClick={this.logout} touch={true} > <Exit /> </IconButton>}
            />
            {this.showstudentpage()}
            <Paper zDepth={1} className="Bottom_nevi">
              <BottomNavigation selectedIndex={this.state.selectedIndex}>
                <BottomNavigationItem
                  label="My Info"
                  icon={recentsIcon}
                  onClick={() => this.student_select(0)}
                />
                <BottomNavigationItem
                  label="Announcement"
                  icon={favoritesIcon}
                  onClick={() => this.student_select(1)}
                />
                <BottomNavigationItem
                  label="Map"
                  icon={nearbyIcon}
                  onClick={() => this.student_select(2)}
                />
              </BottomNavigation>
            </Paper>
          </div>
        </MuiThemeProvider>
      </div>
    );
  }

  showstudentpage(){
    var index = 0;
    for(var i = 0; i < this.state.studentList.length; i++){
      if(this.state.user.email === this.state.studentList[i].Email){
        index = i;
        break;
      }
    }
    if(this.state.selectedIndex === 0){
      return(
        <div>
          <MuiThemeProvider>
          <Paper zDepth={1} className="bottom">
            <center>
              <ListItem disabled={true} primaryText= {"LockerRoom: " + this.state.studentList[index].LockerRoom}/>
              <ListItem disabled={true} primaryText= {"FirstName: " + this.state.studentList[index].FirstName}/>
              <ListItem disabled={true} primaryText= {"LastName: " + this.state.studentList[index].LastName}/>
              <ListItem disabled={true} primaryText= {"Student ID: " + this.state.studentList[index].ID}/>
              <ListItem disabled={true} primaryText= {"Email: " + this.state.studentList[index].Email}/>
              <ListItem disabled={true} primaryText= {"Locker Number: " + this.state.studentList[index].LockerNumber}/>
              <ListItem disabled={true} primaryText= {"Seris Number: " + this.state.studentList[index].LockNumber}/>
              <ListItem disabled={true} primaryText= {"Lock Combination: " + this.state.studentList[index].PassCode}/>
              <ListItem disabled={true} primaryText= {"Grade: " + this.state.studentList[index].Grade}/>
              <ListItem disabled={true} primaryText= {"Instructor: " + this.state.studentList[index].Instructor}/>
              <ListItem disabled={true} primaryText= {"Period: " + this.state.studentList[index].Period}/>
              </center>
            </Paper>
          </MuiThemeProvider>
        </div>
      );
    }else if(this.state.selectedIndex === 1){

      return(
        <div>
          <MuiThemeProvider>
            <Paper zDepth={1} className="bottom">
              <center>
                <h1>{this.state.today}</h1>
                {this.showAnn()}
              </center>
            </Paper>
          </MuiThemeProvider>
        </div>
      );
    }else if(this.state.selectedIndex === 2){
      return(
        <div>
          <img className="Map" alt="MVHS Map" src={require('./Img/Map.png')} />
        </div>
      );
    }
  }

  showAnn(){
    var str = this.state.student_Message;
    if(str === "No Content!"){
      return(
        <h2>No content!</h2>
      );
    }else{
      var res = str.substring(0,str.length-3).split("///");
      return(
        <div>
        {res.map( (item) =>  <li>{item}</li>)}
       </div>
      );
    }
  }

  showWaitingPage(){
    return (
      <div>
        <MuiThemeProvider>
          <div>
            <center><CircularProgress size={100} thickness={10} /></center>
            <center><h3>Waiting For Your Instructor To Approve Your Request...</h3></center>
            <center><FlatButton label="Logout To The Menu Page"
            onClick={this.logout}
            /></center>
          </div>
        </MuiThemeProvider>
      </div>
    );
  }
  showMainPage(){
    if(this.state.loading){
      return (
        <div className="center">
          <MuiThemeProvider>
            <center>
            <CircularProgress size={100} thickness={10} />
            </center>
          </MuiThemeProvider>
          <center>Loading the page...</center>
        </div>
      );
    }
    else if( this.state.user === null){
      if(this.state.currentpage === "Login" || this.state.currentpage === "Info"){
        return(this.showMenuPage());
      }
    }
    else{
      if(this.state.adminList.length===0){
        return (
        <div className="center">
          <MuiThemeProvider>
            <div>
            <CircularProgress size={100} thickness={10} />
            </div>
          </MuiThemeProvider>
          <center>Initializing...</center>
        </div>
      );
      }else if(this.CheckID()){
        return(this.showAdminLoginPage());
      }else{
        if(this.CheckStudentList()){
          return(this.showStudentMenuPage());
        }else if(this.CheckPreStudentList()){
          return(this.showWaitingPage());
        }else{
          return(this.showStudentLoginPage());
        }
      }
    }
  }
  render() {
    return (
      <div>
        {this.showMainPage()}
      </div>
    );
  }
}

render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js